import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'clock', 'Clock', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-0"}],["path",{"d":"M12 7v5l3 3","key":"svg-1"}]]);